/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export default function Options({ id, name, keyValue, selected, preview }) {
  return (
    <option selected={selected} key={keyValue} value={id}>
      {/* <div className="table-color-group-sponsor">
              <div className="color-box" style={{ backgroundImage: preview }}></div>
              {name}
            </div> */}
            {name}
    </option>
  );
}
